export enum SECONDS {
    ONE = 1000,
    TWO = 2000,
    THREE = 3000,
    FOUR = 4000,
    FIVE = 5000
}
